/**
 * Extrai a mensagem de erro devolvida pelo backend (axios), com fallback.
 * Fonte única — substitui o cast repetido em cada hook.
 *
 * Contrato de erro do backend (ErrorResponse): { status, message, errors? }
 * — `errors` só vem em 422 (validação), mapa campo → mensagem.
 */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  const data = (
    err as { response?: { data?: { message?: string; errors?: Record<string, string> } } }
  )?.response?.data;

  // 422: as mensagens por campo são mais úteis que o "Erro de validação" genérico
  if (data?.errors && Object.keys(data.errors).length > 0) {
    return Object.values(data.errors).join(' ');
  }

  return data?.message ?? fallback;
}
